module.exports = __webpack_public_path__ + "static/media/sagar-result.c0685655.png";